
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import NavigationMenu from '../../components/feature/NavigationMenu';

export default function CrowdfundingEngPage() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [fundingAmount, setFundingAmount] = useState(127500);
  const [backers, setBackers] = useState(342);
  const [daysLeft, setDaysLeft] = useState(45);

  const slides = [
    {
      type: 'video',
      content: 'https://www.youtube.com/embed/4Xf3McA6dVU?autoplay=1&mute=1&loop=1&playlist=4Xf3McA6dVU',
      title: 'A Gift from the Sea — A Revolution for Our Bodies',
      subtitle: 'Eco-friendly feminine hygiene products made with marine biotechnology'
    },
    {
      type: 'image',
      content: 'https://public.readdy.ai/ai/img_res/d139bbf65cb0aa51973753f3fb7aed5a.jpg',
      title: 'Innovative Marine Biotechnology',
      subtitle: 'Advanced technology inspired by nature'
    },
    {
      type: 'image',
      content: 'https://readdy.ai/api/search-image?query=Beautiful%20pristine%20ocean%20waves%20meeting%20clean%20sandy%20beach%2C%20crystal%20clear%20turquoise%20water%2C%20natural%20marine%20environment%20representing%20purity%20and%20sustainability%2C%20peaceful%20seascape%20with%20gentle%20waves&width=1920&height=1080&seq=ocean-purity&orientation=landscape',
      title: 'The Power of Pure Ocean',
      subtitle: 'Protecting women\'s health and the environment simultaneously'
    }
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 8000);
    return () => clearInterval(timer);
  }, [slides.length]);

  const targetAmount = 250000;
  const progressPercentage = Math.round((fundingAmount / targetAmount) * 100);

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <header className="absolute top-0 left-0 right-0 z-50 bg-gradient-to-r from-teal-600/90 to-blue-600/90 backdrop-blur-sm">
        <div className="container mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <Link to="/" className="text-2xl font-bold text-white" style={{ fontFamily: '"Pacifico", serif' }}>
              Marine Pad
            </Link>
            <NavigationMenu />
            <Link
              to="/"
              className="bg-white text-teal-600 px-6 py-2 rounded-full font-semibold hover:bg-teal-50 transition-colors whitespace-nowrap"
            >
              Back to Home
            </Link>
          </div>
        </div>
      </header>

      {/* Hero Carousel */}
      <section className="relative h-screen overflow-hidden">
        {slides.map((slide, index) => (
          <div
            key={index}
            className={`absolute inset-0 transition-opacity duration-1000 ${
              index === currentSlide ? 'opacity-100' : 'opacity-0'
            }`}
          >
            {slide.type === 'video' ? (
              <iframe
                src={slide.content}
                className="w-full h-full object-cover"
                allow="autoplay; encrypted-media"
                allowFullScreen
              />
            ) : (
              <img
                src={slide.content}
                alt={slide.title}
                className="w-full h-full object-cover object-top"
              />
            )}
            <div className="absolute inset-0 bg-black/40" />
          </div>
        ))}

        {/* Carousel Content */}
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="text-center text-white max-w-4xl px-6">
            <h1 className="text-5xl md:text-7xl font-bold mb-6 leading-tight">
              {slides[currentSlide].title}
            </h1>
            <p className="text-xl md:text-2xl mb-8 opacity-90">
              {slides[currentSlide].subtitle}
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button className="bg-teal-500 hover:bg-teal-600 text-white px-8 py-4 rounded-full text-lg font-semibold transition-colors whitespace-nowrap">
                Back This Project
              </button>
              <button className="border-2 border-white text-white hover:bg-white hover:text-teal-600 px-8 py-4 rounded-full text-lg font-semibold transition-colors whitespace-nowrap">
                Learn More
              </button>
            </div>
          </div>
        </div>

        {/* Carousel Navigation */}
        <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 flex space-x-3">
          {slides.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentSlide(index)}
              className={`w-3 h-3 rounded-full transition-colors ${
                index === currentSlide ? 'bg-white' : 'bg-white/50'
              }`}
            />
          ))}
        </div>

        {/* Carousel Arrows */}
        <button
          onClick={() => setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length)}
          className="absolute left-6 top-1/2 transform -translate-y-1/2 text-white hover:text-teal-200 transition-colors"
        >
          <i className="ri-arrow-left-line text-3xl"></i>
        </button>
        <button
          onClick={() => setCurrentSlide((prev) => (prev + 1) % slides.length)}
          className="absolute right-6 top-1/2 transform -translate-y-1/2 text-white hover:text-teal-200 transition-colors"
        >
          <i className="ri-arrow-right-line text-3xl"></i>
        </button>
      </section>

      {/* Funding Progress */}
      <section className="py-16 bg-gradient-to-r from-teal-50 to-blue-50">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto">
            <div className="bg-white rounded-2xl shadow-xl p-8">
              <div className="text-center mb-8">
                <h2 className="text-3xl font-bold text-gray-800 mb-4">Crowdfunding Progress</h2>
                <p className="text-gray-600">Join us in revolutionizing women's health and environmental protection</p>
              </div>

              <div className="grid md:grid-cols-3 gap-8 mb-8">
                <div className="text-center">
                  <div className="text-3xl font-bold text-teal-600 mb-2">
                    ${fundingAmount.toLocaleString()}
                  </div>
                  <div className="text-gray-600">Raised</div>
                  <div className="text-sm text-gray-500">Goal: $250,000</div>
                </div>
                <div className="text-center">
                  <div className="text-3xl font-bold text-blue-600 mb-2">{backers}</div>
                  <div className="text-gray-600">Backers</div>
                </div>
                <div className="text-center">
                  <div className="text-3xl font-bold text-orange-600 mb-2">{daysLeft}</div>
                  <div className="text-gray-600">Days Left</div>
                </div>
              </div>

              <div className="mb-6">
                <div className="flex justify-between items-center mb-2">
                  <span className="text-gray-600">Progress</span>
                  <span className="font-semibold text-teal-600">{progressPercentage}%</span>
                </div>
                <div className="w-full bg-gray-200 rounded-full h-4">
                  <div
                    className="bg-gradient-to-r from-teal-500 to-blue-500 h-4 rounded-full transition-all duration-1000"
                    style={{ width: `${progressPercentage}%` }}
                  />
                </div>
              </div>

              <div className="text-center">
                <button className="bg-gradient-to-r from-teal-500 to-blue-500 text-white px-12 py-4 rounded-full text-lg font-semibold hover:from-teal-600 hover:to-blue-600 transition-all whitespace-nowrap">
                  Back This Project
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Project Story */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-4xl font-bold text-gray-800 mb-4">Our Story</h2>
              <p className="text-xl text-gray-600">Revolutionizing feminine hygiene with marine biotechnology</p>
            </div>

            <div className="prose prose-lg max-w-none">
              <div className="bg-gradient-to-r from-teal-50 to-blue-50 rounded-2xl p-8 mb-8">
                <h3 className="text-2xl font-bold text-gray-800 mb-4">The Problem We're Solving</h3>
                <p className="text-gray-700 mb-4">
                  Traditional feminine hygiene products contain Super Absorbent Polymers (SAP) that pose serious health risks to women and environmental threats to our planet. These synthetic chemicals have been linked to fertility issues, hormonal disruption, and contribute to microplastic pollution.
                </p>
                <p className="text-gray-700">
                  Recent studies from German researchers have revealed alarming connections between SAP in baby diapers and infertility. In Korea, women successfully sued manufacturers after widespread demonstrations against SAP use in menstrual products. Europe has restricted SAP use due to microplastic concerns, yet the United States continues unrestricted use.
                </p>
              </div>

              <div className="bg-gradient-to-r from-green-50 to-teal-50 rounded-2xl p-8 mb-8">
                <h3 className="text-2xl font-bold text-gray-800 mb-4">Our Revolutionary Solution</h3>
                <p className="text-gray-700 mb-4">
                  Marine Pad introduces Bio-SA (Bio Super Absorbent) technology - a groundbreaking innovation derived from marine biotechnology. Our 100% natural absorbent material is extracted from sustainable marine sources, providing superior absorption without any harmful chemicals.
                </p>
                <p className="text-gray-700">
                  This revolutionary technology not only protects women's health but also ensures complete biodegradability, making it the first truly sustainable solution in the feminine hygiene industry.
                </p>
              </div>

              <div className="grid md:grid-cols-2 gap-8 mb-8">
                <div className="bg-red-50 rounded-xl p-6">
                  <h4 className="text-xl font-bold text-red-800 mb-4 flex items-center">
                    <i className="ri-alert-line mr-2"></i>
                    Traditional Products
                  </h4>
                  <ul className="space-y-2 text-gray-700">
                    <li className="flex items-start">
                      <i className="ri-close-circle-line text-red-500 mt-1 mr-2"></i>
                      SAP chemicals causing health risks
                    </li>
                    <li className="flex items-start">
                      <i className="ri-close-circle-line text-red-500 mt-1 mr-2"></i>
                      Microplastic environmental pollution
                    </li>
                    <li className="flex items-start">
                      <i className="ri-close-circle-line text-red-500 mt-1 mr-2"></i>
                      Non-biodegradable synthetic materials
                    </li>
                    <li className="flex items-start">
                      <i className="ri-close-circle-line text-red-500 mt-1 mr-2"></i>
                      Potential fertility and hormonal issues
                    </li>
                  </ul>
                </div>

                <div className="bg-teal-50 rounded-xl p-6">
                  <h4 className="text-xl font-bold text-teal-800 mb-4 flex items-center">
                    <i className="ri-leaf-line mr-2"></i>
                    Marine Pad
                  </h4>
                  <ul className="space-y-2 text-gray-700">
                    <li className="flex items-start">
                      <i className="ri-check-circle-line text-teal-500 mt-1 mr-2"></i>
                      100% natural Bio-SA technology
                    </li>
                    <li className="flex items-start">
                      <i className="ri-check-circle-line text-teal-500 mt-1 mr-2"></i>
                      Marine biotechnology innovation
                    </li>
                    <li className="flex items-start">
                      <i className="ri-check-circle-line text-teal-500 mt-1 mr-2"></i>
                      Completely biodegradable materials
                    </li>
                    <li className="flex items-start">
                      <i className="ri-check-circle-line text-teal-500 mt-1 mr-2"></i>
                      Safe for women's health
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Technology Section */}
      <section className="py-16 bg-gradient-to-r from-blue-50 to-teal-50">
        <div className="container mx-auto px-6">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-4xl font-bold text-gray-800 mb-4">Bio-SA Technology</h2>
              <p className="text-xl text-gray-600">The science behind our revolutionary marine biotechnology</p>
            </div>

            <div className="grid md:grid-cols-3 gap-8">
              <div className="bg-white rounded-2xl p-8 shadow-lg">
                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className="ri-microscope-line text-2xl text-blue-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-800 mb-4 text-center">Marine Extraction</h3>
                <p className="text-gray-600 text-center">
                  Our Bio-SA material is sustainably extracted from marine organisms using advanced biotechnology processes that preserve the natural properties while ensuring purity and safety.
                </p>
              </div>

              <div className="bg-white rounded-2xl p-8 shadow-lg">
                <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className="ri-drop-line text-2xl text-teal-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-800 mb-4 text-center">Superior Absorption</h3>
                <p className="text-gray-600 text-center">
                  Bio-SA technology provides exceptional absorption capacity that matches or exceeds traditional SAP while maintaining breathability and comfort throughout use.
                </p>
              </div>

              <div className="bg-white rounded-2xl p-8 shadow-lg">
                <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className="ri-recycle-line text-2xl text-green-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-800 mb-4 text-center">Biodegradable</h3>
                <p className="text-gray-600 text-center">
                  Unlike synthetic polymers, our Bio-SA material completely biodegrades in natural environments, leaving no harmful residues or microplastics behind.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Reward Tiers */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-6">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-800 mb-4">Reward Tiers</h2>
            <p className="text-xl text-gray-600">Choose your support level and get exclusive Marine Pad products</p>
          </div>

          <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
            <div className="bg-gradient-to-br from-teal-50 to-blue-50 rounded-2xl p-8 border-2 border-teal-200">
              <div className="text-center mb-6">
                <h3 className="text-2xl font-bold text-teal-800 mb-2">Early Bird</h3>
                <div className="text-4xl font-bold text-teal-600 mb-2">$25</div>
                <p className="text-gray-600">Limited time offer</p>
              </div>
              <ul className="space-y-3 mb-8">
                <li className="flex items-center">
                  <i className="ri-check-line text-teal-500 mr-3"></i>
                  <span>1 month supply of Marine Pad</span>
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-teal-500 mr-3"></i>
                  <span>Digital thank you card</span>
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-teal-500 mr-3"></i>
                  <span>Project updates</span>
                </li>
              </ul>
              <button className="w-full bg-teal-500 text-white py-3 rounded-full font-semibold hover:bg-teal-600 transition-colors whitespace-nowrap">
                Select Reward
              </button>
            </div>

            <div className="bg-gradient-to-br from-blue-50 to-purple-50 rounded-2xl p-8 border-2 border-blue-200 transform scale-105">
              <div className="text-center mb-6">
                <div className="bg-blue-500 text-white px-3 py-1 rounded-full text-sm font-semibold mb-2 inline-block">
                  Most Popular
                </div>
                <h3 className="text-2xl font-bold text-blue-800 mb-2">Supporter</h3>
                <div className="text-4xl font-bold text-blue-600 mb-2">$50</div>
                <p className="text-gray-600">Best value package</p>
              </div>
              <ul className="space-y-3 mb-8">
                <li className="flex items-center">
                  <i className="ri-check-line text-blue-500 mr-3"></i>
                  <span>3 month supply of Marine Pad</span>
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-blue-500 mr-3"></i>
                  <span>Exclusive Marine Pad tote bag</span>
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-blue-500 mr-3"></i>
                  <span>Behind-the-scenes content</span>
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-blue-500 mr-3"></i>
                  <span>Early access to new products</span>
                </li>
              </ul>
              <button className="w-full bg-blue-500 text-white py-3 rounded-full font-semibold hover:bg-blue-600 transition-colors whitespace-nowrap">
                Select Reward
              </button>
            </div>

            <div className="bg-gradient-to-br from-purple-50 to-pink-50 rounded-2xl p-8 border-2 border-purple-200">
              <div className="text-center mb-6">
                <h3 className="text-2xl font-bold text-purple-800 mb-2">Champion</h3>
                <div className="text-4xl font-bold text-purple-600 mb-2">$100</div>
                <p className="text-gray-600">Premium supporter</p>
              </div>
              <ul className="space-y-3 mb-8">
                <li className="flex items-center">
                  <i className="ri-check-line text-purple-500 mr-3"></i>
                  <span>6 month supply of Marine Pad</span>
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-purple-500 mr-3"></i>
                  <span>Limited edition gift set</span>
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-purple-500 mr-3"></i>
                  <span>Personal thank you video</span>
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-purple-500 mr-3"></i>
                  <span>Lifetime 20% discount</span>
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-purple-500 mr-3"></i>
                  <span>Name on supporter wall</span>
                </li>
              </ul>
              <button className="w-full bg-purple-500 text-white py-3 rounded-full font-semibold hover:bg-purple-600 transition-colors whitespace-nowrap">
                Select Reward
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Impact Section */}
      <section className="py-16 bg-gradient-to-r from-teal-50 to-blue-50">
        <div className="container mx-auto px-6">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-800 mb-4">The Impact We'll Create</h2>
            <p className="text-xl text-gray-600">Together, we can revolutionize women's health and environmental protection</p>
          </div>

          <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
            <div className="text-center bg-white rounded-2xl p-8 shadow-lg">
              <div className="w-16 h-16 bg-pink-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-heart-line text-2xl text-pink-600"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-4">Women's Health Protection</h3>
              <p className="text-gray-600">
                Eliminate SAP-related health risks and provide safe, natural feminine hygiene products that prioritize women's wellbeing and reproductive health.
              </p>
            </div>

            <div className="text-center bg-white rounded-2xl p-8 shadow-lg">
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-earth-line text-2xl text-green-600"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-4">Environmental Protection</h3>
              <p className="text-gray-600">
                Reduce microplastic pollution and create a sustainable future with completely biodegradable feminine hygiene products that protect our planet.
              </p>
            </div>

            <div className="text-center bg-white rounded-2xl p-8 shadow-lg">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-lightbulb-line text-2xl text-blue-600"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-4">Industry Innovation</h3>
              <p className="text-gray-600">
                Pioneer marine biotechnology applications in feminine hygiene, setting new industry standards for safety, sustainability, and innovation.
              </p>
            </div>
          </div>

          <div className="mt-12 text-center">
            <div className="bg-white rounded-2xl p-8 shadow-lg max-w-4xl mx-auto">
              <h3 className="text-2xl font-bold text-gray-800 mb-4">Global Movement for Change</h3>
              <p className="text-gray-600 mb-6">
                Join women worldwide who are demanding safer, more sustainable feminine hygiene products. From Germany's research warnings to Korea's successful lawsuits, and Europe's regulatory actions - the world is ready for change. Help us bring this revolution to every woman, everywhere.
              </p>
              <div className="grid md:grid-cols-3 gap-6 text-center">
                <div>
                  <div className="text-3xl font-bold text-teal-600 mb-2">10M+</div>
                  <div className="text-gray-600">Women affected by SAP risks</div>
                </div>
                <div>
                  <div className="text-3xl font-bold text-blue-600 mb-2">50%</div>
                  <div className="text-gray-600">Reduction in environmental impact</div>
                </div>
                <div>
                  <div className="text-3xl font-bold text-green-600 mb-2">100%</div>
                  <div className="text-gray-600">Natural and biodegradable</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="py-16 bg-gradient-to-r from-teal-600 to-blue-600">
        <div className="container mx-auto px-6 text-center">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-4xl font-bold text-white mb-6">Be Part of the Revolution</h2>
            <p className="text-xl text-white/90 mb-8">
              Every contribution brings us closer to a world where women's health and environmental protection go hand in hand. Join us in creating the future of feminine hygiene.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button className="bg-white text-teal-600 px-12 py-4 rounded-full text-lg font-semibold hover:bg-gray-100 transition-colors whitespace-nowrap">
                Back This Project Now
              </button>
              <button className="border-2 border-white text-white hover:bg-white hover:text-teal-600 px-12 py-4 rounded-full text-lg font-semibold transition-colors whitespace-nowrap">
                Share with Friends
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12">
        <div className="container mx-auto px-6">
          <div className="grid md:grid-cols-4 gap-8">
            <div>
              <h3 className="text-xl font-bold mb-4" style={{ fontFamily: '"Pacifico", serif' }}>
                Marine Pad
              </h3>
              <p className="text-gray-400">
                A gift from the sea that protects women's health and the environment through innovative marine biotechnology.
              </p>
            </div>
            <div>
              <h4 className="font-semibold mb-4">Product</h4>
              <ul className="space-y-2 text-gray-400">
                <li><Link to="/" className="hover:text-white transition-colors">Marine Pad</Link></li>
                <li><Link to="/" className="hover:text-white transition-colors">Bio-SA Technology</Link></li>
                <li><Link to="/sap-dangers" className="hover:text-white transition-colors">SAP Dangers</Link></li>
              </ul>
            </div>
            <div>
              <h4 className="font-semibold mb-4">Company</h4>
              <ul className="space-y-2 text-gray-400">
                <li><Link to="/" className="hover:text-white transition-colors">Our Story</Link></li>
                <li><Link to="/crowdfunding/eng" className="hover:text-white transition-colors">Crowdfunding</Link></li>
                <li><Link to="/admin" className="hover:text-white transition-colors">Admin</Link></li>
              </ul>
            </div>
            <div>
              <h4 className="font-semibold mb-4">Contact</h4>
              <ul className="space-y-2 text-gray-400">
                <li>Email: info@marinepad.com</li>
                <li>Phone: +1-555-MARINE-PAD</li>
                <li>Address: San Francisco, CA</li>
              </ul>
            </div>
          </div>
          <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
            <p>&copy; 2024 Marine Pad. All rights reserved. | 
              <a href="https://readdy.ai/?origin=logo" className="hover:text-white transition-colors ml-2">
                Powered by Readdy
              </a>
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}
